<template>
  <div class="top-form">
    <h3 class="pl-3">
      {{ title }}
    </h3>
    <p>
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: "top-form",

  props : {
    title : {
      type: String,
      required: true,
    },

    description : {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>

</style>